import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  NoDataFound,
  NoDataFoundProps,
} from '~/components/no-data-found/NoDataFound';
import { useTerminalNavigate } from '~/hooks/use-terminal-navigate/useTerminalNavigate';
import { appPaths } from '~/routes/app-paths';

export enum WatchlistNewsEmptyState {
  WatchlistNewsEmpty = 'WatchlistNewsEmpty',
  WatchlistEmpty = 'WatchlistEmpty',
}

export interface NoNewsFoundProps {
  notFoundCondition: WatchlistNewsEmptyState;
}

export const NoNewsFound = ({ notFoundCondition }: NoNewsFoundProps) => {
  const { t } = useTranslation(['news', 'watchlistManager']);
  const navigateTerminal = useTerminalNavigate();

  const navigateToWatchlist = () => {
    navigateTerminal({
      to: appPaths.watchlistManager,
      crumb: { label: t('watchlistManager:title') },
    });
  };

  const notFoundStateSets: Record<WatchlistNewsEmptyState, NoDataFoundProps> = {
    [WatchlistNewsEmptyState.WatchlistNewsEmpty]: {
      bannerPath: '/terminal/static/images/empty-state/not-found.svg',
      title: t('news:emptyNews.title'),
      description: t('news:emptyNews.description'),
      buttonLabel: t('news:addAssets'),
      buttonAction: navigateToWatchlist,
    },
    [WatchlistNewsEmptyState.WatchlistEmpty]: {
      bannerPath: '/terminal/static/images/empty-state/empty-portfolio.svg',
      title: t('news:emptyWatchlist.title'),
      description: t('news:emptyWatchlist.description'),
      buttonLabel: t('news:addAssets'),
      buttonAction: navigateToWatchlist,
    },
  };

  return (
    <NoDataFound
      {...notFoundStateSets[notFoundCondition]}
      data-testid="no-news-found"
    />
  );
};
